var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "500" } },
        [
          _c("w-card-title", [
            _vm._v(_vm._s(_vm.$ct("purchase-inbox-reader-edit-alias"))),
          ]),
          _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("w-info", {
                        attrs: { text: _vm.$ct("inboxreader-alias-info") },
                      }),
                      _c(
                        "div",
                        { staticClass: "flex-box" },
                        [
                          _c("w-input", {
                            attrs: {
                              label: _vm.$ct("inbox-reader-mail-prefix"),
                              fancy: "",
                              "has-error": _vm.showErrorMessage,
                            },
                            on: {
                              focus: function ($event) {
                                return _vm.onFocus()
                              },
                              blur: function ($event) {
                                return _vm.onBlur()
                              },
                            },
                            model: {
                              value: _vm.alias,
                              callback: function ($$v) {
                                _vm.alias = $$v
                              },
                              expression: "alias",
                            },
                          }),
                          _c("div", { staticClass: "domain" }, [
                            _vm._v("@winfakt.app"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "w-transition-slide-height",
                        [
                          _vm.showErrorMessage
                            ? _c("app-error-message-box", [
                                _vm._v(_vm._s(_vm.errorMessage)),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: { disabled: !_vm.canSave, icon: "save" },
                  on: {
                    click: function ($event) {
                      return _vm.save()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$ct("common.save")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }